<script lang="ts">
  export let centers: any;
  export let stats: any;

  import CanesForPrintPart from "./CanesForPrintPart.svelte";

  const canes = getCanes(centers);

  const caneSets = [];

  const maxElts = 8;
  while (canes.length > 0) {

    const newSet = [];
    caneSets.push(newSet);

    for (let i = 0; i < maxElts; i++) {
      if (canes.length > 0) {
        newSet[i] = canes.shift();
      }
    }
  }

  function getCanes(centers: any[]): any[] {
    const canesById = new Map<number, any>();
    const canes = [];

    for (let center of centers) {
      const cane = center.cane;
      const caneId = cane.caneId;
      if (canesById.get(caneId) === undefined) {
        canesById.set(caneId, {
          cane: cane,
          radius: center.radius,
          qty: 1,
        });
      } else {
        canesById.get(caneId).qty++;
      }
    }

    // console.log(canesById);
    for (const [caneId, caneInfo] of canesById) {

      let score = 0;
      const properties = [];
      const cane = caneInfo.cane;

      if (cane.isClassicSignature) {
        properties.push('classic signature');
        score += 10;
      }
      if (cane.isRareSignature) {
        properties.push('rare signature');
        score += 20;
      }
      if (cane.isUnique) {
        properties.push('unique');
        score += 2;
      }
      if (cane.fromLib) {
        properties.push('from lib');
        score += 5;
      }
      if (cane.isCentral) {
        properties.push('central');
        score += 8;
      }
      const complexity = cane.elts.length;
      if (complexity === stats.simplestCane) {
        properties.push('simple');
      }
      if (complexity === stats.mostComplexCane) {
        properties.push('complex');
        score += 4;
      }

      score += complexity;

      canes.push({
        id: caneId, 
        qty: caneInfo.qty,
        complexity: complexity, 
        props: properties, 
        caneData: cane,
        score: score,
      });
    }
    
    canes.sort((caneA, caneB) => {
      return caneB.score - caneA.score;     
    });
    
    //console.log(canes);
    return canes;
  };

  const labels = [
    ['classic signature', 'sig'],
    ['rare signature', 'rsig'],
    ['unique', 'u'],
    ['from lib', 'lib'],
    ['central', 'c'],
    ['simple', 's'],
    ['complex', 'c'],
  ];

  const showQty = stats.caneSetType !== 'allDifferent';

</script>

<span>
  keys:
  <span class="properties">
    {#if showQty}<span class='quantity property'>quantity</span>{/if}<span class='complexity property'>complexity</span>{#each labels as label}
      <span class={label[0].replace(/\s+/g, '_')  + ' property'}>
        {label[1]} = {label[0]}
      </span>
    {/each}
  </span>
  <table>
    <tbody>
      {#each caneSets as caneSet}
        <tr>
          {#each caneSet as cane}
            <CanesForPrintPart {cane} {labels} {showQty} />
          {/each}
        </tr>
      {/each}
    </tbody>
  </table>
</span>

<style>
</style>
